import styled from "styled-components";

import heroBg from "../../../assets/images/pattern-white.jpg";

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Hero = styled.div`
  position: relative;
  width: 100%;
  color: #fff;
  background-color: #533fa4;
`;

export const HeroImageContainer = styled.div`
  width: 100%;
  height: 264px;
  background-image: url(${heroBg});
  background-repeat: no-repeat;
  background-position-x: left;
  background-position-y: top;
  mix-blend-mode: multiply;

  @media (width < 4000px) {
    background-size: 2260px auto;
  }

  @media (width >= 4000px) {
    background-size: 100% auto;
  }
`;

export const HeroContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0;
  padding: 24px;
`;

export const Title = styled.h1`
  font-size: 65px;
  font-weight: 500;
  line-height: 68px;
  text-align: center;
`;

export const FeaturesSection = styled.div`
  display: flex;
  flex-direction: column;
  color: #fff;
  background-color: #533fa4;

  @media (width < 1024px) {
    gap: 48px;
    padding: 53px 38px;
  }

  @media (width >= 1024px) {
    gap: 62px;
    padding: 114px 32px;
  }
`;

export const FeaturesTitle = styled.h2`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;

  @media (width >= 1024px) {
    text-align: center;
  }
`;

export const FeaturesList = styled.ul`
  display: flex;

  @media (width < 1024px) {
    flex-direction: column;
    gap: 51px;
    padding-left: 20px;
  }

  @media (width >= 1024px) {
    justify-content: center;
    gap: 48px;
  }

  @media (width >= 1440px) {
  }
`;

export const FeaturesListItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media (width < 1024px) {
  }

  @media (width >= 1024px) {
    &.--1 {
      width: 290px;
    }
    &.--2 {
      width: 230px;
    }
    &.--3 {
      width: 220px;
    }
    &.--4 {
      width: 210px;
    }
  }

  @media (width >= 1440px) {
  }
`;

export const FeaturesListTitle = styled.h5`
  font-size: 40px;
  font-weight: 700;
  line-height: 42px;
`;

export const FeaturesListDesc = styled.p`
  font-size: 17px;
  line-height: 25px;
  letter-spacing: 0.17px;
`;

export const ArtistsGridContainer = styled.div`
  display: flex;
  justify-content: center;

  @media (width < 1024px) {
    padding: 45px 50px;
  }

  @media (width >= 1024px) {
    padding: 93px 50px;
  }
`;

export const ArtistsGrid = styled.div`
  width: 100%;

  @media (width < 768px) {
    display: flex;
    flex-direction: column;
    row-gap: 58px;
  }

  @media (width >= 768px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 38px;
    row-gap: 85px;
    max-width: 630px;
  }

  @media (width >= 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
    max-width: 964px;
  }

  @media (width >= 1440px) {
    grid-template-columns: 1fr 1fr 1fr 1fr;
    max-width: 1298px;
  }
`;
